export default __webpack_public_path__ + "static/media/Silver_3_Rank.d48e9a13.png";